import { computed, ref } from 'vue';
import BillingAPI from 'dashboard/api/billing';

const RESTRICTED_STATUSES = ['frozen', 'trial_ended', 'pending_payment'];

export const BILLING_ALLOWED_ROUTE_NAMES = [
  'general_settings_billing',
  'general_settings_billing_plans',
  'general_settings_whatsapp_fees',
  'general_settings_ai_billing',
  'settings_inbox_list',
  'settings_inbox_new',
  'settings_inbox_show',
  'settings_inbox_finish',
  'settings_inbox_agents',
  'general_info_index',
  'agent_list',
  'agent_edit',
  'settings_teams_list',
  'settings_teams_new',
  'settings_teams_finish',
  'settings_teams_add_agents',
  'settings_teams_show',
  'settings_teams_edit',
  'settings_teams_edit_members',
  'settings_teams_edit_finish',
  'security_settings_index',
];

const billingState = ref({
  loaded: false,
  displayStatus: null,
});

export function useBillingAccess() {
  const displayStatus = computed(() => billingState.value.displayStatus);

  const isBillingRestricted = computed(() => {
    if (!billingState.value.loaded) return false;

    const status = (billingState.value.displayStatus || '').toLowerCase();
    return RESTRICTED_STATUSES.includes(status);
  });

  const loadBillingAccess = async () => {
    try {
      const { data } = await BillingAPI.getSubscription();
      const sub = data?.subscription;
      const status = sub?.display_status || sub?.status || null;

      billingState.value = {
        loaded: true,
        displayStatus: status ? String(status).toLowerCase() : null,
      };
    } catch {
      billingState.value = { loaded: true, displayStatus: null };
    }
  };

  const resetBillingAccess = () => {
    billingState.value = { loaded: false, displayStatus: null };
  };

  const isRouteAllowedWhenRestricted = routeName =>
    BILLING_ALLOWED_ROUTE_NAMES.includes(routeName);

  return {
    displayStatus,
    isBillingRestricted,
    loadBillingAccess,
    resetBillingAccess,
    isRouteAllowedWhenRestricted,
    BILLING_ALLOWED_ROUTE_NAMES,
  };
}
